// import React, { useState, useEffect } from 'react';
// import '../../Dashboard Style/GenealogyTree.css';
// import { useSelector } from 'react-redux';
// import axios from 'axios';
// import { toast } from 'react-toastify';

// // Import your local icons from the Dashboard folder
// import adminIcon from './admin-icon.png'; 
// import userIcon from './user-icon.png';
// import { getDirectByUsercodeApi } from '../../Services/Operations/ProductAPI';

// const GenealogyLeadTree = () => {
//   const authToken = useSelector((state) => state.user?.token);
//   const userData = useSelector((state) => state.user?.userData);

//   // Initialize tree with local admin icon for the Root
//   const [treeData, setTreeData] = useState({
//     id: userData?.user_code || '',
//     name: userData?.name || 'Loading...',
//     image: adminIcon, // Use admin icon for the top-level user
//     children: [],
//     isLoaded: false
//   });

//   useEffect(() => {
//     if (userData?.user_code && authToken) {
//       handleNodeClick(treeData.id);
//     }
//   }, [userData, authToken]);

// const fetchChildrenData = async (userCode) => {
//   try {
//     console.log("Fetching direct children for:", userCode);
    
//     const response = await getDirectByUsercodeApi(authToken, userCode);
    
//     console.log("Direct API Response:", response);
    
//     if (response.status && response.data) {
//       // Transform the API response to match your tree structure
//       return response.data.map(item => {
//         // Check if this is an empty slot
//         const isEmpty = !item.id || item.id === '';
        
//         // Get the name - use item.name if it exists, otherwise combine firstName/lastName
//         let name = item.name;
//         if (!name && (item.firstName || item.lastName)) {
//           name = `${item.firstName || ''} ${item.lastName || ''}`.trim();
//         }
        
//         return {
//           id: item.id || '', // Use item.id from response
//           name: name || item.accountName || 'Empty Slot',
//           image: item.image || userIcon, 
//           children: item.children || [],
//           isLoaded: item.isLoaded || false,
//           position: item.position?.charAt(0) || 'L', // Convert "Left" to "L", "Right" to "R"
//           isEmpty: isEmpty,
//           // Include additional data for reference
//           email: item.email,
//           accountName: item.accountName,
//           directCount: item.directCount || 0,
//           status: item.status || 'Inactive'
//         };
//       });
//     }
    
//     console.warn("API returned false status or no data");
//     return [];
//   } catch (error) {
//     console.error("Error fetching direct genealogy:", error);
//     return [];
//   }
// };

//   const handleNodeClick = async (targetId) => {
//     // Prevent clicking if there is no user code
//     if (!targetId) return;

//     const newChildren = await fetchChildrenData(targetId);
//     const updateNodes = (node) => {
//       if (node.id === targetId) {
//         if (node.children.length === 0) {
//           return { ...node, children: newChildren, isLoaded: true };
//         }
//         return node;
//       }
//       return {
//         ...node,
//         children: node.children ? node.children.map(updateNodes) : []
//       };
//     };
//     setTreeData(prevTree => updateNodes(prevTree));
//   };

//   const renderNode = (node, isRoot = false) => {
//     const hasChildren = node.children && node.children.length > 0;
//     // Check if node is disabled
//     const isDisabled = !node.id || node.isEmpty;

//     return (
//       <li key={node.id || Math.random()}>
//         <div 
//           className={`member-view-box ${isDisabled ? 'node-disabled' : ''}`} 
//           onClick={() => !isDisabled && handleNodeClick(node.id)}
//         >
//           {!isRoot && (
//             <div className="member-header">
//               <span>{node.name}</span>
//             </div>
//           )}
//           <div className="member-image">
//             <img src={node.image} alt="Member" />
//           </div>
        
//         </div>
        
//         {hasChildren && (
//           <ul className="active">
//             {node.children.map(child => renderNode(child, false))}
//           </ul>
//         )}
//       </li>
//     );
//   };
//   return (
//     <div className="genealogy-body genealogy-scroll">
//       <div className="genealogy-tree">
//         {treeData.id ? (
//           <ul>{renderNode(treeData, true)}</ul>
//         ) : (
//           <p className="loading-text">Loading Tree...</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default GenealogyLeadTree;


// import React, { useState, useEffect } from 'react';
// import '../../Dashboard Style/GenealogyTree.css';
// import { useSelector } from 'react-redux';
// import axios from 'axios';
// import { toast } from 'react-toastify';

// // Import your local icons from the Dashboard folder
// import adminIcon from './admin-icon.png'; 
// import userIcon from './user-icon.png';
// import { getDirectByUsercodeApi } from '../../Services/Operations/ProductAPI';

// const GenealogyLeadTree = () => {
//   const authToken = useSelector((state) => state.user?.token);
//   const userData = useSelector((state) => state.user?.userData);

//   // Track which nodes are expanded and which have been clicked once
//   const [expandedNodes, setExpandedNodes] = useState(new Set());
//   const [firstClickNodes, setFirstClickNodes] = useState(new Set());
//   const [hoveredNode, setHoveredNode] = useState(null);

//   // Initialize tree with local admin icon for the Root
//   const [treeData, setTreeData] = useState({
//     id: userData?.user_code || '',
//     name: userData?.name || 'Loading...',
//     image: adminIcon,
//     children: [],
//     isLoaded: false
//   });

//   useEffect(() => {
//     if (userData?.user_code && authToken) {
//       // Initially expand the root node
//       setExpandedNodes(new Set([treeData.id]));
//       handleNodeClick(treeData.id, true); // Force load root children
//     }
//   }, [userData, authToken]);

// const fetchChildrenData = async (userCode) => {
//   try {
//     const response = await getDirectByUsercodeApi(authToken, userCode);
    
//     if (response && response.status && response.data) {
//       return response.data.map(item => ({
//         ...item,
//         id: item.id || item.user_code || `temp-id-${Math.random()}`, // Add this line
//         image: item.image || userIcon,
//         children: [],
//         isLoaded: false,
//         isEmpty: !item.id && !item.user_code, // Add this line
//         name: item.name || item.accountName || 'Empty Slot'
//       }));
//     }
//     return [];
//   } catch (error) {
//     console.error("Error fetching direct genealogy:", error);
//     return [];
//   }
// };

// const handleNodeClick = async (targetId, forceExpand = false) => {
//   // Don't return early for empty targetId - we still want to show tooltips
//   // But we need to handle empty nodes differently

//   // If it's the first click (not expanded yet and not already first-clicked)
//   // We need to check if this node is empty or not
//   const isNodeExpanded = expandedNodes.has(targetId);
//   const isFirstClick = firstClickNodes.has(targetId);
  
//   // For empty nodes (no targetId), we only want to show tooltip, not load children
//   if (!targetId) {
//     // Generate a temporary ID for this empty node to track it
//     const tempId = `empty-${Date.now()}-${Math.random()}`;
    
//     if (!isFirstClick) {
//       // Mark as first click and show hover/tooltip
//       setFirstClickNodes(prev => new Set([...prev, tempId]));
//       setHoveredNode(tempId);
//     } else {
//       // Remove tooltip if already showing
//       setFirstClickNodes(prev => {
//         const newSet = new Set([...prev]);
//         newSet.delete(tempId);
//         return newSet;
//       });
//       setHoveredNode(null);
//     }
//     return;
//   }

//   // For nodes WITH targetId, proceed with existing logic
//   if (!isNodeExpanded && !isFirstClick && !forceExpand) {
//     // Mark as first click and show hover/tooltip
//     setFirstClickNodes(prev => new Set([...prev, targetId]));
//     setHoveredNode(targetId);
//     return;
//   }

//   // Second click or force expand - actually load children
//   if (!isNodeExpanded || forceExpand) {
//     const newChildren = await fetchChildrenData(targetId);
//     const updateNodes = (node) => {
//       if (node.id === targetId) {
//         if (node.children.length === 0 || forceExpand) {
//           return { ...node, children: newChildren, isLoaded: true };
//         }
//         return node;
//       }
//       return {
//         ...node,
//         children: node.children ? node.children.map(updateNodes) : []
//       };
//     };
//     setTreeData(prevTree => updateNodes(prevTree));
//     setExpandedNodes(prev => new Set([...prev, targetId]));
//   } else {
//     // If already expanded, collapse it
//     setExpandedNodes(prev => {
//       const newSet = new Set([...prev]);
//       newSet.delete(targetId);
//       return newSet;
//     });
//   }
  
//   // Remove from first click set
//   setFirstClickNodes(prev => {
//     const newSet = new Set([...prev]);
//     newSet.delete(targetId);
//     return newSet;
//   });
//   setHoveredNode(null);
// };

//   const handleCloseHover = () => {
//     setHoveredNode(null);
//     setFirstClickNodes(prev => {
//       const newSet = new Set([...prev]);
//       newSet.delete(hoveredNode);
//       return newSet;
//     });
//   };

//   // Render hover tooltip for first click
// const renderHoverTooltip = (node) => {
//   if (hoveredNode !== node.id) return null;

//   return (
//     <div className="node-hover-tooltip">
//       <div className="tooltip-content">
//         <button 
//           className="close-tooltip-btn" 
//           onClick={(e) => {
//             e.stopPropagation();
//             handleCloseHover();
//           }}
//         >
//           ×
//         </button>
        
//         {/* Main Node Info */}
//        <div style={{ fontSize: '10px', lineHeight: '1.2', color: '#333' }}>
//   <h4 style={{ fontSize: '12px', margin: '0 0 2px 0', fontWeight: 'bold' }}>{node.name}</h4>
//   <p style={{ margin: '0 0 2px 0' }}><span>Pos:</span> {node.position}</p>

//   {/* Sponsor Section */}
//   {node.sponsor && (
//     <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee' }}>
//       <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#999', marginBottom: '2px', textTransform: 'uppercase' }}>
//         Sponsor
//       </p>
//       <p style={{ margin: '0' }}><span>Code:</span> {node.sponsor.user_code}</p>
//       <p style={{ margin: '0' }}><span>Acc:</span> {node.sponsor.account_name}</p>
//       <p style={{ margin: '0' }}><span>Email:</span> {node.sponsor.email}</p>
//     </div>
//   )}

//   {/* Placement Section */}
//   {node.placement && (
//     <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee' }}>
//       <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#999', marginBottom: '2px', textTransform: 'uppercase' }}>
//         Placement
//       </p>
//       <p style={{ margin: '0' }}><span>Code:</span> {node.placement.user_code}</p>
//       <p style={{ margin: '0' }}><span>Acc:</span> {node.placement.account_name}</p>
//       <p style={{ margin: '0' }}><span>Email:</span> {node.placement.email}</p>
//     </div>
//   )}
// </div>
//       </div>
//     </div>
//   );
// };

//   const renderNode = (node, isRoot = false) => {
//     const hasChildren = node.children && node.children.length > 0;
//     const isDisabled = !node.id || node.isEmpty;
//     const isExpanded = expandedNodes.has(node.id);
//     const isFirstClick = firstClickNodes.has(node.id);
// console.log("node ;;;;;;;;",node)
//     return (
//       <li key={node.id || Math.random()}>
//         <div className="node-container">
//           <div 
//             className={`member-view-box ${isDisabled ? 'node-disabled' : ''} ${isFirstClick ? 'first-click' : ''}`} 
//             onClick={(e) => {
//               e.stopPropagation();
//               handleNodeClick(node.id, false, node);
//             }}
//             onMouseLeave={() => {
//               // Auto-close hover after delay
//               if (isFirstClick) {
//                 setTimeout(() => {
//                   setHoveredNode(null);
//                   setFirstClickNodes(prev => {
//                     const newSet = new Set([...prev]);
//                     newSet.delete(node.id);
//                     return newSet;
//                   });
//                 }, 3000);
//               }
//             }}
//           >
//             {!isRoot && (
//               <div className="member-header">
//                 <span>{node.name}</span>
//               </div>
//             )}
//             <div className="member-image">
//               <img src={node.image} alt="Member" />
//               {isFirstClick && !isExpanded && (
//                 <div className="first-click-indicator">👆</div>
//               )}
//             </div>
//           </div>
          
//           {isFirstClick && renderHoverTooltip(node)}
//         </div>
        
//         {hasChildren && isExpanded && (
//           <ul className="active">
//             {node.children.map(child => renderNode(child, false))}
//           </ul>
//         )}
//       </li>
//     );
//   };

//   return (
//     <div className="genealogy-body genealogy-scroll">
//       <div className="genealogy-tree">
//         {/* {treeData.id ? ( */}
//           <ul>{renderNode(treeData, true)}</ul>
//         {/* ) : (
//           <p className="loading-text">Loading Tree...</p>
//         )} */}
//       </div>
//     </div>
//   );
// };

// export default GenealogyLeadTree;

import React, { useState, useEffect } from 'react';
import '../../Dashboard Style/GenealogyTree.css';
import { useSelector } from 'react-redux';
import adminIcon from './admin-icon.png'; 
import userIcon from './user-icon.png';
import { getDirectByUsercodeApi } from '../../Services/Operations/ProductAPI';

const GenealogyLeadTree = () => {
  const authToken = useSelector((state) => state.user?.token);
  const userData = useSelector((state) => state.user?.userData);

  const [expandedNodes, setExpandedNodes] = useState(new Set());
  const [firstClickNodes, setFirstClickNodes] = useState(new Set());
  const [hoveredNode, setHoveredNode] = useState(null);

  const [treeData, setTreeData] = useState({
    id: userData?.user_code || '',
    user_code: userData?.user_code || '', 
    package_id: userData?.package_id || 0,
    name: userData?.name || 'Loading...',
    account_name: userData?.account_name || '', 
    image: adminIcon,
    children: [],
    isLoaded: false
  });

  useEffect(() => {
    if (userData?.user_code && authToken) {
      setExpandedNodes(new Set([treeData.id]));
      handleNodeClick(treeData.id, true);
    }
  }, [userData, authToken]);

  const fetchChildrenData = async (userCode) => {
    try {
      const response = await getDirectByUsercodeApi(authToken, userCode);
      if (response && response.status && response.data) {
        return response.data.map(item => ({
          ...item,
          // Use 'id' from your API response as the user_code
          id: item.id || `temp-${Math.random()}`,
          user_code: item.id, 
          package_id: item.package_id || 1, // Fallback if missing
          name: item.name || `${item.firstName} ${item.lastName}`,
          image: item.image || userIcon,
          children: [],
          isLoaded: false
        }));
      }
      return [];
    } catch (error) {
      console.error("Error fetching genealogy:", error);
      return [];
    }
  };

  const handleNodeClick = async (targetId, forceExpand = false) => {
    if (!targetId) return;
    const isNodeExpanded = expandedNodes.has(targetId);
    const isFirstClick = firstClickNodes.has(targetId);

    if (!isNodeExpanded && !isFirstClick && !forceExpand) {
      setFirstClickNodes(prev => new Set([...prev, targetId]));
      setHoveredNode(targetId);
      return;
    }

    if (!isNodeExpanded || forceExpand) {
      const newChildren = await fetchChildrenData(targetId);
      const updateNodes = (node) => {
        if (node.id === targetId) {
          return { ...node, children: newChildren, isLoaded: true };
        }
        return {
          ...node,
          children: node.children ? node.children.map(updateNodes) : []
        };
      };
      setTreeData(prevTree => updateNodes(prevTree));
      setExpandedNodes(prev => new Set([...prev, targetId]));
    } else {
      setExpandedNodes(prev => {
        const newSet = new Set([...prev]);
        newSet.delete(targetId);
        return newSet;
      });
    }
    setFirstClickNodes(prev => {
      const newSet = new Set([...prev]);
      newSet.delete(targetId);
      return newSet;
    });
    setHoveredNode(null);
  };

    const handleCloseHover = () => {
    setHoveredNode(null);
    setFirstClickNodes(prev => {
      const newSet = new Set([...prev]);
      newSet.delete(hoveredNode);
      return newSet;
    });
  };
  // Render hover tooltip for first click
const renderHoverTooltip = (node) => {
  console.log("node............ : ",node)
  if (hoveredNode !== node.id) return null;

  return (
    <div className="node-hover-tooltip">
      <div className="tooltip-content">
        <button 
          className="close-tooltip-btn" 
          onClick={(e) => {
            e.stopPropagation();
            handleCloseHover();
          }}
        >
          ×
        </button>
        
        {/* Main Node Info */}
       <div style={{ fontSize: '10px', lineHeight: '1.2', color: '#333' }}>
  <h4 style={{ fontSize: '12px', margin: '0 0 2px 0', fontWeight: 'bold' }}>{node.name}</h4>
  <p style={{ margin: '0 0 2px 0' }}><span>Pos:</span> {node.position}</p>
  <p style={{ margin: '0 0 2px 0' }}><span>Code:</span> {node.user_code}</p>
  <p style={{ margin: '0 0 2px 0' }}><span>Acc:</span> {node?.accountName}</p>

  {/* Sponsor Section */}
  {node.sponsor && (
    <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee' }}>
      <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#999', marginBottom: '2px', textTransform: 'uppercase' }}>
        Sponsor
      </p>
      <p style={{ margin: '0' }}><span>Code:</span> {node.sponsor.user_code}</p>
      <p style={{ margin: '0' }}><span>Acc:</span> {node.sponsor.account_name}</p>
      {/* <p style={{ margin: '0' }}><span>Email:</span> {node.sponsor.email}</p> */}
    </div>
  )}

  {/* Placement Section */}
  {node.placement && (
    <div style={{ marginTop: '4px', paddingTop: '4px', borderTop: '1px solid #eee' }}>
      <p style={{ fontSize: '9px', fontWeight: 'bold', color: '#999', marginBottom: '2px', textTransform: 'uppercase' }}>
        Placement
      </p>
      <p style={{ margin: '0' }}><span>Code:</span> {node.placement.user_code}</p>
      <p style={{ margin: '0' }}><span>Acc:</span> {node.placement.account_name}</p>
      {/* <p style={{ margin: '0' }}><span>Email:</span> {node.placement.email}</p> */}
    </div>
  )}
</div>
      </div>
    </div>
  );
};


  const renderNode = (node, isRoot = false) => {
    const hasChildren = node.children && node.children.length > 0;
    const isExpanded = expandedNodes.has(node.id);
    const isFirstClick = firstClickNodes.has(node.id);
const isDisabled = !node.id || node.isEmpty;
    // LOGIC: Check 'id' for active status and 'package_id' for premium
    const hasCode = !!node.id; 
    const pkgId = Number(node.package_id) || 0;

    let statusClass = 'node-inactive';
    if (hasCode) {
      statusClass = pkgId > 1 ? 'node-premium' : 'node-active';
    }

    return (
      <li key={node.id || Math.random()}>
        <div className="node-container">
          <div 
            className={`member-view-box ${isDisabled ? 'node-disabled' : ''} ${statusClass} ${isFirstClick ? 'first-click' : ''}`} 
            onClick={() => handleNodeClick(node.id)}
          >
            <div className="member-header" >
              <span>{node.name}</span>
            </div>
            <div className="member-image" style={{ backgroundColor: isDisabled ? "white" : "" }}>
              <img src={node.image || userIcon} alt="Member" />
              {statusClass === 'node-premium' && <div className="package-badge">★</div>}
            </div>
          </div>
          
          {/* Tooltip logic simplified for visibility */}
         {isFirstClick && renderHoverTooltip(node)}
        </div>
        {hasChildren && isExpanded && (
          <ul className="active">
            {node.children.map(child => renderNode(child, false))}
          </ul>
        )}
      </li>
    );
  };

  

  return (
    <div className="genealogy-body genealogy-scroll">
      <div className="tree-legend">
        <div className="legend-item"><span className="dot premium"></span> Plan Purchase User</div>
        <div className="legend-item"><span className="dot active"></span> Id Active ($5)</div>
        <div className="legend-item"><span className="dot inactive"></span> Inactive User</div>
      </div>
      <div className="genealogy-tree" style={{    overflow: "auto",
    overflowY: "scroll", overflowX:"scroll"}}>
        <ul>{renderNode(treeData, true)}</ul>
      </div>
    </div>
  );
};

export default GenealogyLeadTree;